import React from 'react';
import { formatInTz } from '../../../lib/date-utils';
import { Card, CardHeader, CardTitle, CardContent } from '@lb-classroom/ui';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Image from 'next/image';
import * as BookingActions from '../../../actions/booking';
import appUtils from '../../../utils/appUtils';
import { i18n, withTranslation } from 'next-i18next';
import MomentFormatter from '../../../utils/MomentFormatter';
import { X } from 'lucide-react';
import Main from './Main';

function mapStateToProps(state) {
  const { booking, modal, geoData, auth } = state;
  const { saving } = booking;
  return {
    currentUser: auth.user,
    fromModal: modal.isOpen,
    saving,
    geoData: geoData.geoData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    bookingActions: bindActionCreators<any, any>(BookingActions, dispatch),
  };
}

const FIFTY_MINUTES = 3000000;

const CancelBookingModalContent = (props) => {
  const {
    t,
    geoData,
    booking,
    saving,
    bookingActions,
    page,
    fromModal,
    currentUser,
    hideModal,
  } = props;
  const startTimestamp = booking.start_at;
  const endTimestamp = booking.ent_at;
  const onClick = (e) => {
    e.preventDefault();
    bookingActions.cancel(booking.id, page, fromModal);
  };

  const timeZone = currentUser?.js_time_zone || geoData.timeZone;
  const currentLocale = appUtils.getLocaleFromLang(i18n.language);
  const avatarUrl = booking.tutor_avatar
    .replace('lingualbox-dev', 'lingualbox')
    .replace('lingualbox-staging-sg', 'lingualbox');
  const momentFormatter = new MomentFormatter(currentLocale, timeZone);
  const dateFormat = momentFormatter.getDateFormatWithYear();
  const timeFormat = momentFormatter.getTimeFormat(startTimestamp);
  const endTimeFormat = momentFormatter.getTimeFormat(endTimestamp);
  const formattedStartTime = formatInTz(
    booking.start_at,
    timeZone,
    timeFormat,
    currentLocale,
  );
  const formattedEndTime = formatInTz(
    booking.end_at,
    timeZone,
    endTimeFormat || timeFormat,
    currentLocale,
  );
  const timeSentence = `${formattedStartTime} - ${formattedEndTime}`;
  const dateSentence = formatInTz(
    booking.start_at,
    timeZone,
    dateFormat,
    currentLocale,
  );
  const ticketToReturn = booking.consumed_tickets;
  const subTicketToReturn = booking.consumed_sub_tickets;
  const lessonDuration =
    booking.end_at - booking.start_at === FIFTY_MINUTES ? '50' : '25';
  const regularTicketSentence =
    ticketToReturn === 0
      ? null
      : t('modals.cancelBooking.ticketToReturn', {
          count: ticketToReturn,
          smart_count: ticketToReturn,
        });
  const subTicketSentence =
    subTicketToReturn === 0
      ? null
      : t('modals.cancelBooking.subTicketToReturn', {
          count: subTicketToReturn,
          smart_count: subTicketToReturn,
        });
  const ticketSentence = [regularTicketSentence, subTicketSentence]
    .filter(Boolean)
    .join(' ');
  return (
    <div className="max-w-lg mx-auto">
      <Card className="z-50">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle>
            <div className="flex items-center">
              <div className="tutor-image">
                <Image
                  width={36}
                  height={36}
                  alt="tutor-avatar"
                  className="rounded-full"
                  src={avatarUrl}
                />
              </div>
              <div className="text-md ml-2">{booking.tutor_name}</div>
            </div>
          </CardTitle>
          <button type="button" className="modal-close" onClick={hideModal}>
            <span className="sr-only">Close</span>
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </CardHeader>
        <CardContent>
          <Main
            saving={saving}
            lessonDuration={lessonDuration}
            handleClick={onClick}
            dateSentence={dateSentence}
            ticketSentence={ticketSentence}
            timeSentence={timeSentence}
          />
        </CardContent>
      </Card>
    </div>
  );
};

const wrapped = withTranslation('common')(CancelBookingModalContent);

export default connect(mapStateToProps, mapDispatchToProps)(wrapped);
